import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressCard, faBanSmoking, faBus, faCoffee, faDumbbell, faParking, faPaw, faSwimmingPool, faWheelchair, faWifi } from '@fortawesome/free-solid-svg-icons';
import _ from 'lodash';
import useSearchHooks from '../../../store/hotel/search-hooks';

const defaultIcon = [
  {
    id: 0,
    icon: <FontAwesomeIcon icon={faWifi} className="fa-amenity-icon" />,
    txt: 'Free Internet Available',
  },
  {
    id: 1,
    icon: <FontAwesomeIcon icon={faCoffee} className="fa-amenity-icon" />,
    txt: 'Free Breakfast',
  },
  {
    id: 2,
    icon: <FontAwesomeIcon icon={faBus} className="fa-amenity-icon" />,
    txt: 'Free Airport Shuttle',
  },
  {
    id: 3,
    icon: <FontAwesomeIcon icon={faParking} className="fa-amenity-icon" />,
    txt: 'Free Parking',
  },
  {
    id: 4,
    icon: <FontAwesomeIcon icon={faBanSmoking} className="fa-amenity-icon" />,
    txt: 'Non Smoking',
  },
  {
    id: 5,
    icon: <FontAwesomeIcon icon={faAddressCard} className="fa-amenity-icon" />,
    txt: 'Business Center',
  },
  {
    id: 6,
    icon: <FontAwesomeIcon icon={faDumbbell} className="fa-amenity-icon" />,
    txt: 'Fitness Center',
  },
  {
    id: 7,
    icon: <FontAwesomeIcon icon={faPaw} className="fa-amenity-icon" />,
    txt: 'Pets Allowed',
  },
  {
    id: 8,
    icon: <FontAwesomeIcon icon={faWheelchair} className="fa-amenity-icon" />,
    txt: 'Accessible',
  },
  {
    id: 9,
    icon: <FontAwesomeIcon icon={faSwimmingPool} className="fa-amenity-icon" />,
    txt: 'Pool',
  },
];
export default function AmenitiesSelection() {
  const [amenities] = useState(defaultIcon);
  const { setAmenities, search } = useSearchHooks();

  return (
    <div className="table_search_right">
      <ul>
        {amenities.map((item) => {
          return (
            <li
              className={_.includes(search.amenities.split(','), item.id.toString()) ? 'act' : ''}
              key={`${item.id}`}
              onClick={() => {
                setAmenities({ amenities: _.xor(search.amenities.split(','), [item.id.toString()]).join(',') });
              }}
            >
              <p>{item.icon}</p>
              <p>{item.txt}</p>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
